import { DateI } from "@customHooks/use-date";
import { useTranslation } from "react-i18next";

export default function UpdateAlert(props: {startDate: DateI, endDate: DateI}) {
    const { t } = useTranslation(['common'])
    
    return (
        <p className="Maintenance">
            <strong>{t('updateAlert.0')} {props.startDate.hour}:{props.startDate.minutes} {props.startDate.hourFormat} {t('updateAlert.1')} {props.endDate.hour}:{props.endDate.minutes} {props.endDate.hourFormat}, {t('updateAlert.2')}</strong>
        </p>
    )
}
